import { useTranslation } from 'react-i18next'

export default function PaywallGuarantee() {
  const { t } = useTranslation()

  return (
    <div className="bg-hw-green-soft rounded-2xl p-5">
      <div className="flex items-start gap-4">
        <span className="border-hw-green text-hw-green flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-[3px] bg-white px-1 text-center text-[9px] leading-tight font-extrabold uppercase">
          {t('pages.checkout.payment.moneyBackGuaranteeTitle')}
        </span>

        <div className="space-y-1.5">
          <p className="text-hw-ink text-lg font-bold">
            {t('pages.checkout.plans.moneyBackGuaranteeComponent.title')}
          </p>

          <p className="text-hw-muted text-sm leading-relaxed">
            {t('pages.checkout.plans.moneyBackGuaranteeComponent.description')}
          </p>
        </div>
      </div>
    </div>
  )
}
